import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate ,useLocation } from 'react-router-dom';
import Ecomheader from "../../src/header/headershop";
import Ecomfooter from "../footer/footershop";
import noimage from '../../src/images/noimage.jpg';
import { useDispatch, useSelector } from "react-redux";
import { addCart, deleteProduct } from "../Redux/Redux";
import ProductWrap from "../../src/product/productWrap";
import NavHead from "../navbarHead";
import MobileMenu from "../../src/navbarHead/mobileNav";
const WishList = () => {

  const [productData, setProductData] = useState([]);
  // const [cart, setCart] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const wishListValue = useSelector((state) => state.wishlist.value);
  const cart = useSelector((state) => state.cart.value);
  const dispatch = useDispatch()
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProductData = async () => {
      setIsLoading(true)
      try {
        // Retrieve productIds from localStorage
        // const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
        const wishlistData = wishListValue || [];

        // Create an array of just the product IDs
        const productIds = wishlistData.map(product => product.productid);

        // Convert the product IDs to a comma-separated string
        const productIdsString = productIds.join(',');
        // Create a FormData object and append the productIds
        const formData = new FormData();
        formData.append("productIds", productIdsString);
        formData.append('currency',localStorage.getItem('currencyName'));

        const response = await fetch(
          `https://api.starmallonline.com/api/v1/product/getByIdarray`,
          {
            method: "PUT",
            body: formData,
          }
        );

        if (response.ok) {
          const productData = await response.json();

          // Make sure that productData is an array of products
          if (Array.isArray(productData)) {
            // Set the initial quantity for each product based on cart data
            const productDataWithQuantity = productData.map(product => ({
              ...product,
              quantity: wishlistData.find(item => item.productid === product.productid)?.quantity || 0,
              wishlistid: wishlistData.find(item => item.productid === product.productid)?.wishlistid || 0,
            }));
            setProductData(productDataWithQuantity);
          } else {
            console.error("Invalid product data format");
          }
        } else {
          console.error("Failed to fetch product data");
        }
        setIsLoading(false)
      } catch (error) {
        console.error("Error fetching product data:", error);
        setIsLoading(false)
      }
    };

    fetchProductData();
  }, [wishListValue]);


  

  return (
    <div>
      <Ecomheader />
      <MobileMenu/>
      <div className=" ">
{/* //       <aside className="col-lg-3 col-xxl-sidebar page-sidebar sidebar sidebar-fixed sticky-sidebar-wrapper">
//
//            <NavHead/>
//
//        </aside>
//        <div className="col-lg-9 col-xxl-content bside"> */}
      {!isLoading && <div className="container homebg">
            <div className="row">
              {productData.map((product, index) => (
                  <ProductWrap key={product.productid} product={product} /> 
              ))}
              {productData.length == 0 && <div className="">
                <img src="https://storage.megashop.my/noproduct.jpg" alt="test" className="rounded mx-auto d-block " />
                No Product in Wishlist
                </div>}
            </div>

      </div>}
      {/* {isLoading && <div className="flex items-center justify-center">
        <svg aria-hidden="true" className="w-20 h-20 my-10 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
            </svg>
        </div>} */}
      <Ecomfooter />
{/* //       </div> */}
    </div>
    </div>
  );
}
export default WishList;
